import React from 'react'

const BottomCells = (props) => {
    return(
        <>
            <td className='bigRowTotal'>{props.day}</td>
            <tr>
                <td className='littleRowHTwoOhTotal'>H2OL</td>
                <td className='littleRowHTwoOhTotal'>{props.routeAmount}</td>
                <td className='littleRowHTwoOhTotal'>{props.miles}</td>
                <td className='littleRowHTwoOhTotal'>{props.LWP}</td>
                <td className='littleRowHTwoOhTotal'>{props.LVP}</td>
                <td className='littleRowHTwoOhTotal'>{props.jumper}</td>
                <td className='littleRowHTwoOhTotal'>{props.Training}</td>
                <td className='littleRowHTwoOhTotal'>{parseFloat(props.support).toFixed(2)}</td>
                <td className='littleRowHTwoOhTotal'>{props.R2}</td>
                <td className='littleRowHTwoOhTotal'>{props.R4}</td>
                <td className='littleRowHTwoOhTotal'>{props.R6}</td>
                <td className='littleRowHTwoOhTotal'></td>
                <td className='littleRowHTwoOhTotal'></td>
                <td className='littleRowHTwoOhTotal'></td>
            </tr>
        </>
    )
}

export default BottomCells